import React from "react";
//import React, { useState } from "react";
import "./styles/ProductHeader.css";


const ProductHeader = ({ formData, updateFormData, goToStep, navigateToPage }) => {


    const saveJsonFile = async () => {
        try {
            const updatedFormData = {
                ...formData,
                currentPage: formData.currentPage || "wizard", // ✅ Ensure the correct page is stored
                currentStep: formData.currentStep > 1 ? formData.currentStep : 1 // ✅ Ensure the last visited step is stored
            };

            const fileHandle = await window.showSaveFilePicker({
                suggestedName: "Soft EstimateProject.json",
                types: [
                    {
                        description: "JSON File",
                        accept: { "application/json": [".json"] },
                    },
                ],
            });

            const writableStream = await fileHandle.createWritable();
            await writableStream.write(new Blob([JSON.stringify(updatedFormData, null, 2)], { type: "application/json" }));
            await writableStream.close();

            alert("File saved successfully!");
        } catch (error) {
            console.error("Error saving file:", error);
            alert("Failed to save file.");
        }
    };



    const defaultValues = {
        projectName: '',
        startDate: '',
        budget: '',
        estimatedHours: '',
        implementationType: '',

        preferredResources: [
            { name: "", hourlyRate: 0, count: 0 }
        ],

        techStack: [],

        sprintsMilestones: [
            {
                name: "",
                duration: 0,
                startDate: "",
                endDate: "",
                actualStartDate: "",   // ✅ Sprint Start Date
                actualEndDate: "",     // ✅ Sprint End Date
                totalAllocatedHours: 0,
                totalBandwidthHours: 0,
                workingDays: 0,
                utilizationRate: 0,
                sprintCost: 0,
                holidays: []
            }
        ],

        projectExpenses: [
            { item: "", manufacturer: "", description: "", quantity: 0, unitPrice: 0, totalCost: 0 }
        ],

        industry: '',
        comments: '',
        stateTax: '',
        isFBTechStack: true,
        currentStep: 1,
        currentPage: 'dashboard',

        estimatePreparedBy: '',
        estimatePreparedFor: '',
        termsAndConditions: '',
        weekendDays: [],
        holidays: [],

        totalProjectCost: 0,
        costBreakdownByResource: [
            { resource: "", cost: 0 }
        ],
        businessHoursPerDay: 8,
        totalResourceCount: 0,
        allocationMatrix: [],
        resourceTable: []
    };




    const confirmAndNavigate = (destination) => {
        //const confirmNavigation = window.confirm("Do you want to save your progress before leaving?");
        //if (confirmNavigation) {
        // if (formData) {
        //     Object.keys(formData).forEach(key => formData[key] = ""); // ✅ Clears all fields
        // }

        // Assign default values to formData
        Object.assign(formData, defaultValues);

        if (destination === "home") {
            localStorage.removeItem("isSubscribed"); // ✅ Logs out user
            navigateToPage("home");
        } else if (destination === "dashboard") {
            navigateToPage("dashboard"); // ✅ Go to dashboard
        }
        // }
    };

    return (
        <div className="product-header">
            {/* <h1 className="product-title">Soft Estimate</h1>
            <p className="product-subtitle">Welcome to Your Project Estimation Journey!</p> */}

            <div className="button-container">
                <button className="top-button dashboard-button" onClick={() => confirmAndNavigate("dashboard")}>
                    Dashboard
                </button>
                <button className="save-button" onClick={saveJsonFile}>
                    Save Progress
                </button>                
                <button className="top-button home-button" onClick={() => confirmAndNavigate("home")}>
                    Logout
                </button>
            </div>


        </div>
    );
};

export default ProductHeader;
